import { render, staticRenderFns } from "./card-producto-busqueda.vue?vue&type=template&id=f7656bbe&scoped=true"
import script from "./card-producto-busqueda.vue?vue&type=script&lang=js"
export * from "./card-producto-busqueda.vue?vue&type=script&lang=js"
import style0 from "./card-producto-busqueda.vue?vue&type=style&index=0&id=f7656bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7656bbe",
  null
  
)

export default component.exports